// src/store/worker/workerThunk.js

import { createAsyncThunk } from "@reduxjs/toolkit";
import { getCookie } from "cookies-next";
import { toast } from "react-toastify";
import axiosInstance from "utils/axios";
const token = getCookie("token");

export const createWorkerAction = createAsyncThunk(
  "worker/create",
  async ({ Name, Behaviour, BotType, onSuccess, onError }, thunkAPI) => {
    try {
      const response = await axiosInstance.post("/Workers/Create-Worker", {
        Name,
        Behaviour,
        BotType,
      });
      if (response.status === 200) {
        toast.success("Chatbot created successfully!");
        onSuccess();
        return response.data.details;
      } else {
        toast.error("Failed to create Chatbot.");
        onError(response.data);
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (error) {
      toast.error("Failed to create Chatbot.");
      onError(error);
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const deleteWorkerAction = createAsyncThunk(
  "worker/delete",
  async ({ Id, onSuccess, onError }, thunkAPI) => {
    try {
      const response = await axiosInstance.post("/Workers/Delete-Worker", {
        Id,
      });

      if (response.status === 200) {
        onSuccess();
        toast.success("Chatbot deleted successfully!");
        return Id;
      }

      const errorMessage =
        response.status === 403
          ? "You are not authorized to delete this Chatbot"
          : response.data.details || "Failed to delete Chatbot";

      toast.error(errorMessage); // Show the error toast
      onError(errorMessage);
      return thunkAPI.rejectWithValue(errorMessage);
    } catch (error) {
      const errorMessage =
        error.response?.data?.details ||
        error.message ||
        "An unknown error occurred";
      toast.error(errorMessage); // Show the error toast
      onError(errorMessage);
      return thunkAPI.rejectWithValue(errorMessage);
    }
  }
);

export const updateWorkerAction = createAsyncThunk(
  "worker/update",
  async (
    { Id, Name, BotType, Behaviour, onSuccess, onError, Status },
    thunkAPI
  ) => {
    try {
      const response = await axiosInstance.post("/Workers/Update-Worker", {
        Id,
        Name,
        BotType,
        Behaviour,
        Status,
      });
      if (response.status === 200) {
        toast.success("Chatbot updated successfully!");
        onSuccess();

        return { Id, Name, Behaviour, BotType, Status };
      } else {
        toast.error(response.data.details || "Failed to update Chatbot");
        onError(response.data.details);
        return thunkAPI.rejectWithValue(response.data.details);
      }
    } catch (error) {
      onError(error);
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const fetchWorkersAction = createAsyncThunk(
  "worker/fetchAll",
  async (_, thunkAPI) => {
    try {
      const response = await axiosInstance.get("/Workers/Get-Workers");
      if (response.status === 200) {
        return response.data.details;
      } else {
        toast.error("Failed to fetch chatbots");
        return thunkAPI.rejectWithValue("Failed to fetch chatbots");
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.details || error.message
      );
    }
  }
);

export const switchWorkerStatusAction = createAsyncThunk(
  "worker/switchStatus",
  async ({ id, onSuccess, onError }, thunkAPI) => {
    try {
      const response = await axiosInstance.post("/Workers/Switch-Type", {
        workerId: id,
      });
      if (response.status === 200) {
        onSuccess();
        toast.success("Chatbot status switched successfully!");
        return { id };
      } else {
        toast.error(response.data.details || "Failed to switch chatbot status");
        onError(response.data.details);
        return thunkAPI.rejectWithValue(response.data.details);
      }
    } catch (error) {
      onError(error);
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// CHANGE THE WORKER.. in leads table..

export const changeWorkerAction = createAsyncThunk(
  "worker/changeWorker",
  async ({ LeadAssignmentId, Id }, thunkAPI) => {
    try {
      const response = await axiosInstance.post("/Workers/Change-Worker", {
        LeadAssignmentId,
        Id,
      });
      if (response.status === 200) {
        return { LeadAssignmentId, Worker: response.data.details.WorkerName };
      } else {
        return thunkAPI.rejectWithValue(
          response.data.details || "Failed to change chatbot"
        );
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.details || error.message
      );
    }
  }
);

export const getUnassignedBots = createAsyncThunk(
  "worker/get unassigned-workers",
  async (thunkAPI) => {
    try {
      const response = await axiosInstance.get("/Workers/unassigned-workers");
      if (response.status === 200) {
        console.log("response: ", response);
        return response.data.details;
      } else {
        return thunkAPI.rejectWithValue(
          response.data.details || "Failed to change chatbot"
        );
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.details || error.message
      );
    }
  }
);

export const unassignWorker = createAsyncThunk(
  "worker/unassign-worker",
  async ({ worker_id }, thunkAPI) => {
    try {
      const response = await axiosInstance.post("/Workers/unassign-worker", {
        worker_id,
      });

      if (response.status === 200) {
        console.log("response: ", response);
        return response.data.details;
      } else {
        return thunkAPI.rejectWithValue(
          response.data.details || "Failed to unassign worker"
        );
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.details || error.message
      );
    }
  }
);
